import * as yup from 'yup';

export const tipoAccionSchema = yup.object({
  tipoAccionId: yup.string().optional(),
  nombre: yup
    .string()
    .required('El nombre es obligatorio')
    .matches(
      /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9.,\s]+$/,
      'Solo se permiten letras, números, espacios, puntos y comas'
    ),
  estado: yup.boolean().required(),
});
